/**
 * Client mirror of the server's per-team feature registry
 * (server/app/api/service_helpers/team_privileges.py). The server resolves the
 * effective flags onto the profile payload; the defaults here only cover the
 * window before the profile loads and the TeamsAdmin editor's checkbox list.
 */
export type TeamPrivileges = Record<string, boolean>;

export const FEATURE_DEFAULTS: TeamPrivileges = {
  magnet_config: false,
};

export const FEATURE_LABELS: Record<string, string> = {
  magnet_config: 'Multi-magnet calibration (count & spacing)',
};

/** Overlay a team's stored overrides onto the defaults (unknown keys dropped). */
export function resolvePrivileges(raw?: TeamPrivileges | null): TeamPrivileges {
  const resolved: TeamPrivileges = { ...FEATURE_DEFAULTS };
  for (const key of Object.keys(raw ?? {})) {
    if (key in FEATURE_DEFAULTS) {
      resolved[key] = Boolean(raw?.[key]);
    }
  }
  return resolved;
}
